import { styled as o } from "styled-components";
import { Theme as i } from "../../styles/themes/index.js";
import { MediaQuery as t } from "../../styles/variables.js";
import { BodyLight as r } from "../../styles/typography/index.js";
import { SmartLink as e } from "../SmartLink/index.js";
const l = o.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: rgb(${i.colors.Juliet});
  border: 1px solid rgb(${i.colors.Golf});
  border-radius: 12px;
  width: 100%;
`, c = o(e)`
  text-decoration: none;
  display: contents;
`, x = o.div`
  height: 32px;
  width: 32px;
  min-width: 32px;
  border-radius: 4px;
  overflow: hidden;

  img {
    border-radius: 4px;
    width: 100%;
    aspect-ratio: 1/1;
  }
`, m = o.div`
  ${r}
  max-width: 227px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0;
  color: rgb(${i.colors.Alpha});

  @media ${t.SCREEN_MD_UP} {
    max-width: unset;
  }
`, h = o.div`
  width: 1px;
  background: rgb(${i.colors.Golf});
  height: 32px;
  display: flex;
`, g = o.div`
  display: flex;
  i {
    color: rgb(${i.colors.Brand});
    font-size: 24px;
  }
`, f = o.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
  width: calc(95% - 24px);
`;
export {
  l as Container,
  f as Content,
  h as Divider,
  x as ImageContainer,
  c as ProductLink,
  m as ProductName,
  g as SeeProduct
};
